import React, { useContext } from 'react'
import { TemplateContext } from '../../components/template/context'
import { Template } from '../../components/template'
import { FormFormik } from './form'
import { useChangePassword } from './hooks'

export const ChangePassword = () => {
  const { setIsLoading } = useContext(TemplateContext)

  useChangePassword(setIsLoading)

  return (
    <Template>
      <FormFormik setIsLoading={setIsLoading} />
    </Template>
  )
}
